import { Form } from 'antd';
import { Text } from 'components/mvp-typography';
import { FormQuestion } from './_components/form-questions';

export function FormQuestionGroupDisplay(props: {
  title: string;
  questions: FormQuestion[];
}) {
  return (
    <div>
      <Text style={{ fontWeight: 'bold' }}>{props.title}</Text>
      {props.questions.map(question => {
        const Prompt = question.component;
        return (
          <Form.Item
            key={`clinic-info-edit-${question.name}`}
            name={question.name}
            rules={question.rules}
            required={question.required}
            label={question.label}
            tooltip={question.tooltip}
          >
            {Prompt}
          </Form.Item>
        );
      })}
    </div>
  );
}
